module.exports = __webpack_public_path__ + "img/cambioclimatico.d2c1f1e4.svg";